import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { colorAttentionBlue50, colorFunctionalGray30, colorFunctionalGray70, IconCheckboxChecked, IconCheckboxIndeterminate, IconCheckboxUnchecked, } from "@rhumbix/rmbx_design_system_design_tokens";
const Checkbox = ({ checked, disabled, indeterminate, onChange, checkedColor, uncheckedColor, indeterminateColor, className, }) => {
    const inputRef = useRef(null);
    const disabledColor = colorFunctionalGray30;
    useEffect(() => {
        if (inputRef.current && indeterminate != null) {
            inputRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);
    return (React.createElement(Container, { className: className },
        React.createElement("input", { type: "checkbox", checked: checked, disabled: disabled, ref: inputRef, onChange: () => onChange(!checked) }),
        checked ? (React.createElement(IconCheckboxChecked, { color: checkedColor ?? disabled ? disabledColor : colorAttentionBlue50 })) : indeterminate ? (React.createElement(IconCheckboxIndeterminate, { color: indeterminateColor ?? disabled ? disabledColor : colorFunctionalGray70 })) : (React.createElement(IconCheckboxUnchecked, { color: uncheckedColor ?? disabled ? disabledColor : colorFunctionalGray70 }))));
};
const Container = styled.div `
    position: relative;
    // Override sizing with styled-components.
    width: 20px;
    height: 20px;

    input {
        position: absolute;
        width: 100%;
        height: 100%;

        cursor: pointer;
        appearance: none;
        border: 0;
        margin: 0;
        outline: none !important;
    }

    svg {
        position: absolute;
        width: 100%;
        height: 100%;

        pointer-events: none;
    }
`;
export default Checkbox;
